import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { Changelog } from "@/types/general";

const changelogApiToken = import.meta.env.VITE_CHANGELOG_API_TOKEN;

export const externalApiSlice = createApi({
    reducerPath: "external_api",
    baseQuery: fetchBaseQuery(),
    endpoints: (builder) => ({
        getChangelogs: builder.query<Changelog.Root[], {locale: "en" | "no", itemsPerPage: number, currentPage: number}>({
            query: ({ locale, itemsPerPage, currentPage }) => ({
                url: `https://changelog.suppli.cloud/api/web-changelogs`,
                headers: {
                    "Authorization": `Bearer ${changelogApiToken}`
                },
                params: {
                    locale,
                    itemsPerPage,
                    currentPage,
                    sort: "publishedAt:desc"
                }
            }),
            transformResponse: (r: { data: Changelog.Root[] }) => r.data
        })
    })
});

export const {
    useGetChangelogsQuery
} = externalApiSlice;